import { IRawStyle } from "@fluentui/react";
import React from "react";
import { Badge, BadgeColor } from "sprint-common-web";

import { Notes } from "../../../../../../common/components/notes/Notes";
import { NoteSubjectType } from "../../../../../../common/types/NoteSubjectType";
import { SprintAccessRight } from "../../../../../../core/security/SprintAccessRight";
import { useCloudFileDashboard } from "../../../common/context/useCloudFileDashboard";

export interface FileRecordNotesSectionProps {
    style?: IRawStyle;
    areNotesDisabled: boolean;
}

export const FileRecordNotesSection = ({ style, areNotesDisabled }: FileRecordNotesSectionProps): JSX.Element => {
    const { cloudFileId, lookupFileRecordId } = useCloudFileDashboard();

    const sourceIds = [cloudFileId];

    if (lookupFileRecordId) {
        sourceIds.push(lookupFileRecordId);
    }

    return (
        <Notes
            subjectId={cloudFileId}
            sourceIds={sourceIds}
            style={style}
            subjectType={NoteSubjectType.CloudFile}
            isInlineCreateSupported={true}
            isDeleteSupported={true}
            accessRights={[SprintAccessRight.CiReadWrite]}
            disabled={areNotesDisabled}
            renderBadge={(note) => {
                if (note.subjectId === lookupFileRecordId) {
                    return (
                        <Badge
                            text="On-Prem"
                            color={BadgeColor.Blue}
                            size={12}
                            testId="note-on-prem-badge"
                            tooltipContent="File record note"
                        />
                    );
                }

                if (note.subjectId === cloudFileId) {
                    return (
                        <Badge
                            text="Cloud"
                            color={BadgeColor.LightGreen}
                            size={12}
                            testId="note-cloud-badge"
                            tooltipContent="Cloud file note"
                        />
                    );
                }

                return <></>;
            }}
        />
    );
};
